import { render, staticRenderFns } from "./activity-records.vue?vue&type=template&id=d8029248&scoped=true"
import script from "./activity-records.vue?vue&type=script&lang=js"
export * from "./activity-records.vue?vue&type=script&lang=js"
import style0 from "./activity-records.vue?vue&type=style&index=0&id=d8029248&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8029248",
  null
  
)

export default component.exports